import {
	Button,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import { useGetFileWithMetadata } from "../../../../api/queries/files.queries";
import { useDocumentStore } from "../../../../stores/document.store";
import { FileStatusChip } from "../../../common/files/FileStatusChip";
import { AddDocumentButton } from "../AddDocumentButton";

export interface DocumentRowDefinition {
	label: string;
	fileIds: string[];
	onAddFile: (fileId: string) => void;
}

interface ReceptionDocumentsTableProps {
	constructionSiteId: number;
	documentRows: DocumentRowDefinition[];
}

export const ReceptionDocumentsTable = ({
	constructionSiteId,
	documentRows,
}: ReceptionDocumentsTableProps) => {
	return (
		<div className="space-y-4">
			<h3 className="text-lg font-medium">Pièces justificatives</h3>
			<div className="rounded-lg border border-gray-200">
				<Table className="table-fixed w-full">
					<TableHeader>
						<TableRow>
							<TableHead>Type</TableHead>
							<TableHead>Fichier(s)</TableHead>
							<TableHead>Statut</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{documentRows.map((row) => (
							<TableRow key={row.label}>
								<TableCell className="truncate">{row.label}</TableCell>
								<TableCell className="truncate align-top">
									<DocumentFiles fileIds={row.fileIds} />
								</TableCell>
								<TableCell className="truncate align-top">
									<div className="flex flex-col gap-2">
										<DocumentFilesStatus fileIds={row.fileIds} />
										<div>
											<AddDocumentButton
												constructionSiteId={constructionSiteId}
												onUploadSuccess={row.onAddFile}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
		</div>
	);
};

const DocumentFiles = ({ fileIds }: { fileIds: string[] }) => {
	const selectDocument = useDocumentStore((state) => state.selectDocument);

	const handleFileClick = (fileId: string) => {
		selectDocument("", fileId, "", "");
	};

	return (
		<div className="flex flex-col gap-2">
			{fileIds.map((fileId) => (
				<DocumentFileItem
					key={fileId}
					fileId={fileId}
					onClick={() => handleFileClick(fileId)}
				/>
			))}
		</div>
	);
};

const DocumentFileItem = ({
	fileId,
	onClick,
}: {
	fileId: string;
	onClick: () => void;
}) => {
	const { data: fileData, isLoading } = useGetFileWithMetadata(fileId);

	if (isLoading) {
		return (
			<div className="animate-pulse">
				<div className="h-4 bg-gray-200 rounded w-3/4" />
			</div>
		);
	}

	if (!fileData) {
		return (
			<span className="text-sm text-gray-500">
				Fichier non trouvé ({fileId})
			</span>
		);
	}

	const handleClick = (event: React.MouseEvent) => {
		event.preventDefault();
		event.stopPropagation();
		onClick();
	};

	return (
		<Button
			type="button"
			variant="link"
			size="sm"
			onClick={handleClick}
			className="p-0 py-1 h-auto font-normal text-primary text-left justify-start"
		>
			{fileData.name}
		</Button>
	);
};

const DocumentFilesStatus = ({ fileIds }: { fileIds: string[] }) => {
	return (
		<div className="flex flex-col gap-2">
			{fileIds.map((fileId) => (
				<div key={fileId}>
					<FileStatusChip humanProcessingStatus="TO_BE_PROCESSED" />
				</div>
			))}
		</div>
	);
};
